var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w8jan0av3a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    d: "M0 0H32V32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w8jan0av3a)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3498d8",
    fillRule: "evenodd",
    d: "M26.292 4.725H3.61a1.625 1.625 0 0 0-1.62 1.62v13.772a1.625 1.625 0 0 0 1.62 1.62h22.682a1.625 1.625 0 0 0 1.62-1.62V6.346a1.625 1.625 0 0 0-1.62-1.621z",
    transform: "translate(3.039 7.494) translate(-1.99 -4.725)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.51 11.286h1.3l-.648-1.62zm18.065-3.079h-3.321l-.81.891-.729-.891h-7.048l-.648 1.458-.648-1.458H8.536v.648l-.324-.648H5.781l-2.349 5.671h2.835l.324-.891H7.4l.324.891h3.159v-.648l.243.648h1.62l.243-.729v.729h6.481l.81-.891.729.891h3.321l-2.106-2.835zm-9.8 4.861h-.891v-3.16l-1.377 3.159H11.7l-1.382-3.159v3.159H8.455l-.324-.891H6.186l-.324.891H4.809l1.7-4.05h1.379l1.539 3.807V9.017h1.539l1.215 2.754 1.134-2.754h1.539v4.05zm8.02 0h-1.217l-1.053-1.377-1.215 1.377h-3.646V9.017h3.726l1.134 1.3 1.215-1.3h1.134l-1.782 2.025zm-6.238-3.24v.729h2.025v.81h-2.026v.81h2.268l1.053-1.215-.977-1.135z",
    transform: "translate(3.039 7.494) translate(2.349 5.671) translate(-3.432 -8.207)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.cb0b2ab702c42303998371ebdb68a464.svg";
export { ForwardRef as ReactComponent };